import React from 'react';
import ClasificacionAreaTrajador from './ClasificacionAreaTrabajador';

const ConfiguracionTrabajador = ({ trabajador = {} }) => {
  return ( 
    <div className="ConfiguracionTrabajador">
      <ClasificacionAreaTrajador
        area={trabajador.area}
        clasificacion={trabajador.clasificacion}
        roles_adicionales={trabajador.roles_adicionales}
      />
    </div>
  );
}
 
export default ConfiguracionTrabajador;